import styled, { css } from "styled-components";
import { Styles } from "styled-components/dist/types";

import { StyledContent as StyledSelectionDDContent, StyledItemsContainer } from "../SelectionDropdown/styles";

export const StyledItemsWrap = styled(StyledItemsContainer)`
    padding: 8px;
`;

export const StyledContent = styled(StyledSelectionDDContent)`
    min-width: 320px;
    width: auto;
`;

export const StyledContainer = styled.div`
    margin-left: 4px;
    position: relative;
`;
